<div
  class="bg-color-teal-50 u-borderRadius--4px u-padding-16 u-marginBottom-24"
>
  <div fxLayout="row" fxLayoutGap="4px" class="color-teal-700 u-marginBottom-8">
    <mat-icon class="md-18" fontSet="material-icons-outlined"
      >lightbulb</mat-icon
    >
    <p>
      <b>{{ title }}</b>
    </p>
  </div>
  <p class="u-marginBottom-8" [innerHTML]="body"></p>
</div>
